import { config } from './config.js';
import { WishlistCollectionReference } from '../../@types/wishlist.js';

interface WishlistAdd {
  syan: number;
  colorId?: string;
  articleId?: string;
  added?: string;
  purchased?: string;
  collectionReferences?: WishlistCollectionReference[];
}

interface WishlistRemove {
  syan: number;
  colorId?: string;
}

export interface WishlistApi {
  add(data: WishlistAdd): Promise<boolean>;

  send(path: string, method: HttpMethod, data: WishlistAdd | WishlistRemove | string): Promise<boolean>;

  remove(data: WishlistRemove): Promise<boolean>;

  merge(): Promise<boolean>;
}

type HttpMethod = 'GET' | 'POST' | 'DELETE' | 'PUT';

export const WishlistApiInstance: WishlistApi = {
  async add(data: WishlistAdd) {
    if (data.syan === undefined) {
      return false;
    }
    try {
      await WishlistApiInstance.send('item', 'POST', data);
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  },

  async remove(data: WishlistRemove) {
    if (data.syan === undefined) {
      return false;
    }
    try {
      await WishlistApiInstance.send('item', 'DELETE', data);
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  },

  async send(path: string, method: HttpMethod, data: WishlistAdd | WishlistRemove) {
    const url = `${config.apiEndpoint}${path}`;
    const fetchOptions: RequestInit = {
      method,
      mode: 'same-origin',
      credentials: 'same-origin',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    };

    if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function') {
      fetchOptions.signal = AbortSignal.timeout(5000);
    }

    const response = await fetch(url, fetchOptions);

    if (response.status >= 400) {
      throw new Error(`wishlist api call failed: ${await response.text()}`);
    }
    return true;
  },

  async merge() {
    try {
      await WishlistApiInstance.send('merge', 'POST', '');
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  },
};
